enum RETURN_TYPES {
  REPLACEMENT = 'REPLACEMENT',
  EXCHANGE = 'EXCHANGE',
  REFUND = 'REFUND',
  REFUND_TO_STORE_CREDIT = 'REFUND_TO_STORE_CREDIT',
}

export default RETURN_TYPES
